import { Deserialize } from 'root/utils/serialize/serialize';
import { SerializeForm } from 'root/utils/serialize/serializeForm';

/**
 * FormContext
 * is an object that holds the current form data
 *
 * @typedef {object} FormContext
 *
 * @returns {FormContext}
 */
const FormContext = (function () {
    /**
     * Private vars
     *
     * This is a simplistic approach to private var and has a few draw back
     * - more syntax
     * - cannot be garbage collected when one instance of the FormContext get deleted
     *   However, in our case it is not too bad since in this case
     *   if the object would be destroyed the user would also be redirected to another page
     *
     */
    let privateStore = {};
    let uid = 0;
    /**
     * constructor
     *
     * @param serializer
     * @returns {undefined}
     */
    const constructor = function () {
        this.id = uid++;
        privateStore[this.id] = {};
        privateStore[this.id].form = null;
        privateStore[this.id].fields = null;
        privateStore[this.id].serializedFields = null;
        privateStore[this.id].request = null;
        privateStore[this.id].response = null;
    };

    constructor.prototype = {
        /**
         * Set the request object, typically the <event> object
         *
         * @param {object} request the request object
         */
        setRequest(request) {
            privateStore[this.id].request = request;
        },

        /**
         * getRequest returns the request object, usually an <event> object
         *
         * @returns {object} request object
         */
        getRequest() {
            return privateStore[this.id].request;
        },

        /**
         * setResponse
         * the jsonDecode value of the form submission: example `/rest/forms/master-submit`
         *
         * @param {json|null} the jsonDecode value of the return
         */
        setResponse(res) {
            privateStore[this.id].response = res;
        },

        /**
         * getResponse
         * The response from the form submit example : `/rest/forms/master-submit`
         *
         * @returns {json|null} response object
         */
        getResponse() {
            return privateStore[this.id].response;
        },

        /**
         * getFields return the current form fields in a object form
         *
         * @returns {object|null} key value pair object of the form fields
         */
        getFields() {
            privateStore[this.id].fields = Deserialize(this.getSerializedFields());
            return privateStore[this.id].fields;
        },

        /**
         * getSerializedFields
         *
         * @returns {string|null} serialized form fields
         */
        getSerializedFields() {
            privateStore[this.id].serializedFields = SerializeForm().form(this.getForm());
            return privateStore[this.id].serializedFields;
        },

        /**
         * setForm
         *
         * @param {object} form DOM element
         */
        setForm(form) {
            privateStore[this.id].form = form;
        },

        /**
         * getForm, return the DOM element representing the form
         *
         * @returns {object|null} DOM element
         */
        getForm() {
            if (privateStore[this.id].form === null) {
                console.warn('form not set, returning NULL');
            }
            return privateStore[this.id].form;
        },
        /**
         * get all the input and select fields of the form
         * @returns {[]|NodeListOf<HTMLElementTagNameMap[string]>}
         */
        getAllFormFields() {
            return this.getForm().querySelectorAll('input, select');
        },
    };

    return constructor;
})();

export { FormContext as default };
